const { default: axiosIns } = require('@/libs/axios')

const NativeAdsService = {
  // GET - NativeAdsApiController
  async getNativeAds() {
    return axiosIns.get('admin/nativeads').then(response => response.data)
  },
  async getNativeAd(id) {
    return axiosIns.get(`admin/nativeads/${id}`).then(response => response.data)
  },
  // PUT - NativeAdsApiController
  async updateNativeAd(id, model) {
    return axiosIns.put(`admin/nativeads/${id}`, model).then(response => response.data)
  },
}
export default NativeAdsService
